module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"step":"Publish","publish":"Publish","pleaseWaitAiLoaderTextVoice":"Artificial intelligence is in the process of voicing questions for your job. We expect it to take 3-5 minutes, please wait... If necessary, you can go to other sections. The job will be available in the jobs section after completion of the preparation process","vacancyCreated":"Job created"}}')
  delete Component.options._Ctor
}
